var _path, _rect, _rect2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6C5 4.895 5.895 4 7 4H19C20.105 4 21 4.895 21 6V15C21 16.105 20.105 17 19 17H11L7 21V17H7C5.895 17 5 16.105 5 15V6Z",
    fill: "url(#chatGradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#1A0C00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#1A0C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H22C23.105 14 24 14.895 24 16V19C24 20.105 23.105 21 22 21H20L17.5 23V21H16C14.895 21 14 20.105 14 19V16C14 14.895 14.895 14 16 14Z",
    fill: "url(#bubbleGradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatGradient",
    x1: 5,
    y1: 4,
    x2: 21,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C4B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubbleGradient",
    x1: 14,
    y1: 14,
    x2: 24,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C4B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/Social.a96b661e5e758ace2b6322d5453335a1.svg";
export { ForwardRef as ReactComponent };